// Registers the service worker only in production builds.
// In dev (npm start) the SW is unregistered to avoid stale caches during development.
export function registerSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  // Only register on https (or localhost). CRA dev server uses HMR — keep SW off in dev.
  const isProd = process.env.NODE_ENV === "production";
  if (!isProd && !isLocalhost) return;
  if (!isProd) {
    // dev: unregister any old SW so HMR works cleanly
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Auto-update if a new worker is waiting
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              // New version installed, take over on next reload
              sw.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        // Silent — PWA install is progressive enhancement.
      });
  });
}
